module.exports = __webpack_public_path__ + "img/grimstroke.36f55981.png";